import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Logger } from '../../../logger/Logger';
import { DeferredParser } from '../../DeferredParser';
import { Fetcher } from '../../Fetcher';

import { playerConfigEndpoint } from './endpoints';
import type { PlayerConfigType } from './types';

export interface FetchPlayerConfigParams {
  JSESSIONID: string;
  baseUrl: string;
}

export class PlayerConfigFetcherBase extends DeferredParser<FetchPlayerConfigParams, PlayerConfigType> {
  private operatorGameId?: string;
  private dedicatedLanguage?: string | null;
  private isCrashGame?: boolean;

  constructor() {
    super(({ JSESSIONID, baseUrl }) =>
      Fetcher.fetch<unknown>(`${baseUrl}${playerConfigEndpoint.url}`, {
        params: {
          JSESSIONID,
        },
        format: playerConfigEndpoint.format,
        root: playerConfigEndpoint.root,
      })
    );
  }

  setOperatorGameId(operatorGameId: string): void {
    this.operatorGameId = operatorGameId;
    this.tryToParse();
  }

  setDedicatedLanguage(dedicatedLanguage: string | null): void {
    this.dedicatedLanguage = dedicatedLanguage;
    this.tryToParse();
  }

  setIsCrashGame(isCrashGame: boolean): void {
    this.isCrashGame = isCrashGame;
    this.tryToParse();
  }

  tryToParse(): void {
    if (this.operatorGameId !== undefined && this.dedicatedLanguage !== undefined && this.isCrashGame !== undefined) {
      const options = {
        operatorGameId: this.operatorGameId,
        dedicatedLanguage: this.dedicatedLanguage,
        isCrashGame: this.isCrashGame,
      };
      this.parseWith((data) => {
        updateApiMask(ApiMask.PlayerConfig);
        const parsedPlayerConfig = playerConfigEndpoint.parser(data, options);
        if (!parsedPlayerConfig.countryCode || parsedPlayerConfig.countryCode === '') {
          Logger.logFailure('emptyCountry');
        }
        return parsedPlayerConfig;
      });
    }
  }
}

export const PlayerConfigFetcher = new PlayerConfigFetcherBase();
